import { useMatch } from 'react-router';
import { E_APP_ROUTES } from '@router/enums';

export const useLayoutConfig = () => {
  const isLoading = useMatch(E_APP_ROUTES.LOADING);
  const isReportPage = useMatch(E_APP_ROUTES.REPORT);

  return {
    showHeader: !isLoading,
    // The Footer only appears on Login/NotFound AND if it's not Loading/Report
    showFooter: !isLoading && !isReportPage,
  };
};
